import React from 'react';
import { Card, Typography, Avatar, theme } from 'antd';
import dayjs from 'dayjs';
import WorkspaceFileCard from './WorkspaceFileCard';

const { Text, Paragraph } = Typography;

const stripHtml = (html) => (html ? String(html).replace(/<[^>]*>/g, '') : '');

const displayNameFromComment = (c) => {
  const creator = c?.extra?.creator;
  const portal = c?.extra?.portal_author;
  return (
    creator?.extra?.full_name ||
    [creator?.first_name, creator?.last_name].filter(Boolean).join(' ') ||
    portal?.full_name ||
    'Team'
  );
};

const avatarSrcFromComment = (c) =>
  c?.extra?.creator?.extra?.profile_image || undefined;

function actorInitial(name) {
  const s = String(name || '?').trim();
  return s ? s.charAt(0).toUpperCase() : '?';
}

const WorkspaceThreadReplies = ({ replies, onPreviewFile }) => {
  const { token } = theme.useToken();
  const n = Array.isArray(replies) ? replies.length : 0;
  if (!n) return null;

  return (
    <div className="workspace-admin-thread-replies" style={{ marginBottom: token.marginMD }}>
      <div className="workspace-admin-thread-replies__body">
        <div className="workspace-admin-thread-replies__rail" aria-hidden />
        <div className="workspace-admin-thread-replies__column">
          <div className="workspace-admin-thread-replies__header">
            <Text strong style={{ color: token.colorPrimary, fontSize: 14 }}>
              {n} {n === 1 ? 'reply' : 'replies'}
            </Text>
          </div>
          <Card size="small" className="workspace-admin-thread-replies__shell bg-100">
            <div className="workspace-admin-thread-replies__stack">
              {replies.map((comment) => {
                const name = displayNameFromComment(comment);
                const src = avatarSrcFromComment(comment);
                const isNote = Boolean(comment.is_internal_note);
                const timeLabel = comment.created_at ? dayjs(comment.created_at).format('h:mm A') : '';

                return (
                  <div key={comment.id} className="workspace-admin-thread-replies__row-connector">
                    <div
                      className={`workspace-admin-thread-replies__row${isNote ? ' workspace-admin-thread-replies__row--note' : ''}`}
                      style={
                        isNote
                          ? {
                              backgroundColor: token.colorWarningBg,
                              border: `1px solid ${token.colorWarningBorder}`,
                            }
                          : undefined
                      }
                    >
                      <Avatar
                        size="small"
                        src={src}
                        style={{ flexShrink: 0, backgroundColor: token.colorFillSecondary }}
                      >
                        {!src ? actorInitial(name) : null}
                      </Avatar>
                      <div style={{ minWidth: 0, flex: 1 }}>
                        <div style={{ marginBottom: 4 }}>
                          <Text strong style={{ fontSize: 14 }}>
                            {name}
                          </Text>
                          {timeLabel ? (
                            <Text type="secondary" style={{ fontSize: 12, marginLeft: token.marginXS }}>
                              {timeLabel}
                            </Text>
                          ) : null}
                        </div>
                        {comment.body ? (
                          <Paragraph
                            style={{ marginBottom: 0, whiteSpace: 'pre-wrap', fontSize: 14, lineHeight: 1.55 }}
                          >
                            {stripHtml(comment.body)}
                          </Paragraph>
                        ) : null}
                        {Array.isArray(comment.media) && comment.media.length > 0 ? (
                          <div style={{ marginTop: token.marginXS, display: 'flex', flexDirection: 'column', gap: token.marginXXS }}>
                            {comment.media.map((m) => (
                              <WorkspaceFileCard
                                key={m.id}
                                media={m}
                                compact
                                onPreview={onPreviewFile ? () => onPreviewFile(m) : undefined}
                              />
                            ))}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceThreadReplies;
